import makeList from './makeList.js'

let viewFloor = '電離層棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '電離層棟 入口',
        file: './data/I9e.JPG',
        rotation: 78.24671206442193,
        link: [
          {
            file: './data/I9.JPG',
            position: [ -3745.3667306338543, 1865.598892393685, 2733.0866969869835 ],
          },
          {
            file: './data/I9d.JPG',
            position: [ 3472.262395814815, 1203.0779016940153, -3379.7287421652973 ],
          },
          {
            file: './data/I9a.JPG',
            position: [ 4698.134439598028, 1469.0215817570115, -830.3514686988585 ],
          },
          {
            file: './data/I9b.JPG',
            position: [ 1263.3786540386507, 1573.5591857273014, -4566.902247484168 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 800.7662835249042, 238.82503192848017 ],
          syowaZoom: [ 615.3846153846155, 538.6410256410257 ],
        },
      },
      { description: '電離層棟(1)',
        file: './data/I9c.JPG',
        rotation: 57.96404735942549,
        link: [
          {
            file: './data/I9b.JPG',
            position: [ 3466.1087738761676, 269.1347576852686, 3580.3345839724416 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 800.7662835249042, 238.82503192848017 ],
          syowaZoom: [ 738.4615384615386, 343.76923076923083 ],
        },
      },
      { description: '電離層棟(2)',
        file: './data/I9b.JPG',
        rotation: 112.42820734610433,
        link: [
          {
            file: './data/I9e.JPG',
            position: [ 2409.541079086469, 28.577992686564965, 4374.959601829874 ],
          },
          {
            file: './data/I9a.JPG',
            position: [ 3307.280286062388, 190.48814735113788, 3737.180497312414 ],
          },
          {
            file: './data/I9c.JPG',
            position: [ -3788.172370071131, -12.268407696919207, -3255.422025590692 ],
          },
          {
            file: './data/I9d.JPG',
            position: [ 3785.7228097999227, 118.78598121957151, 3251.805944735051 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 800.7662835249042, 238.82503192848017 ],
          syowaZoom: [ 651.2820512820514, 407.8717948717948 ],
        },
      },
      { description: '電離層棟(3)',
        file: './data/I9a.JPG',
        rotation: 67.05809957126333,
        link: [
          {
            file: './data/I9b.JPG',
            position: [ -4873.374285763994, 1070.0115866356357, 149.0727675715677 ],
          },
          {
            file: './data/I9e.JPG',
            position: [ -4411.763561835665, 365.19325463172726, 2308.2173735599963 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 800.7662835249042, 238.82503192848017 ],
          syowaZoom: [ 502.5641025641026, 484.7948717948717 ],
        },
      },
      { description: '電離層棟 仮眠室',
        file: './data/I9d.JPG',
        rotation: 46.0054935522419,
        link: [
          {
            file: './data/I9b.JPG',
            position: [ -4961.207202526706, 347.3658926904216, 479.7926788122016 ],
          },
          {
            file: './data/I9e.JPG',
            position: [ -4348.671202962037, 97.90044217175844, 2455.1438348381375 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 800.7662835249042, 238.82503192848017 ],
          syowaZoom: [ 551.2820512820514, 412.9999999999999 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
